import Smartlook from 'smartlook-client';

const smartlookInit = () => {
  const result = Smartlook.init('44859297c34aff656d75fa034ecef8c66878d9b9', { region: 'eu' });
  console.debug('[Smartlook] init: ', { result });
};

const smartlookRecordNumbers = () => {
  Smartlook.record({ forms: true, numbers: true, emails: true, ips: true });
};

const smartlookIdentify = (userId: string, userEmail: string) => {
  if (!Smartlook.initialized()) {
    console.error('[Smartlook] is not initialized: ');
    smartlookInit();
  }
  console.debug('[Smartlook]: indentify', { userId, email: userEmail });
  Smartlook.identify(userId, { email: userEmail });
};

export { smartlookIdentify, smartlookRecordNumbers, smartlookInit };
